const Position = Object.freeze({
  Begin: "begin",
  Middle: "middle",
  End: "end",
});

export default Position;
